import { useState } from 'react'
import { Title } from '../../components/Title'

export const HomeSystem = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }

    const systemtext = [
        {
            data: 5,
            text: 'RPG à la liberté de déplacement sans pareil !',
            desc: "Il est possible d'aller librement sur n'importe quel endroit indiqué dans le cercle.",
        },
        {
            data: 6,
            text: 'Le « Combinage »... Une technique de combat permettant de se combiner avec les objets présents sur la carte',
            desc: 'Marona peut permettre à ses alliés fantômes de se combiner avec des roches ou des bouts de bois, afin de se joindre à elle pour ses combats.',
        },
        {
            data: 7,
            text: 'Un pouvoir encore un peu plus hors norme ! Le « Fantôcombinage » !',
            desc: 'Marona peut combiner en elle ses alliés fantômes via son pouvoir de Fantôcombinage, ce qui a pour effet de lui donner une nouvelle apparence !',
        },
        {
            data: 8,
            text: 'Liberté de jeu totale !',
            desc: "Vous voulez vous équiper d'un objet ramassé par terre ? Jeter en dehors de la carte un ennemi un peu trop gênant ? Empiler des objets pour pouvoir atteindre des endroits élevés ? C'est possible grâce à un système de jeu totalement nouveau !",
        },
    ]
    return (
        <div className='my-20 md:my-40 px-4'>
            <Title title='Système' />
            <div className='flex flex-wrap relative gap-12 justify-center mt-20 px-4 md:px-0'>
                {systemtext.map((system, i) => (
                    <div
                        key={i}
                        onClick={() => {
                            handleOpenModal(i + 5)
                        }}
                        className='w-full md:w-[46%] relative'
                    >
                        <p className='absolute text-topsystemMobile lg:text-topsystem text-gradient-homesystem font-pop -top-4 -left-4 -rotate-2'>
                            {system.text}
                        </p>
                        <img
                            className='ss-thumb'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${i + 5}-s.webp`}
                            alt={system.text}
                        />{' '}
                        <h1 className='text-sub font-kiwi text-tilted-system text-shadow-white'>{system.desc}</h1>
                    </div>
                ))}
            </div>
            <div
                onClick={handleCloseModal}
                className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='w-full md:w-[90%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30'
                >
                    <div className='flex flex-row items-center mx-auto md:gap-4'>
                        <div>
                            {modalImage <= 5 ? (
                                <button>
                                    <img
                                        className='w-full brightness-50 min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                        alt='left'
                                    />
                                </button>
                            ) : (
                                <button onClick={() => setModalImage(modalImage - 1)} className=''>
                                    <img
                                        className='w-full min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                        alt='left'
                                    />{' '}
                                </button>
                            )}
                        </div>
                        <div className='relative'>
                            <button
                                onClick={handleCloseModal}
                                className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                            >
                                <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />{' '}
                            </button>
                            <img
                                className='white-drop-shadow'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${modalImage}.webp`}
                                alt='screen shot of game scene'
                            />{' '}
                        </div>
                        <div>
                            {modalImage > 7 ? (
                                <button>
                                    <img
                                        className='w-full brightness-50 min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                        alt='right'
                                    />
                                </button>
                            ) : (
                                <button onClick={() => setModalImage(modalImage + 1)} className=' '>
                                    <img
                                        className='w-full min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                        alt='right'
                                    />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>{' '}
        </div>
    )
}
